import {Component, ViewChild, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from "../../shared/pipes/translate.pipe";
import {HeadlineComponent} from "../../shared/elements/headline/headline.component";
import {IconBadgeComponent} from "../../shared/elements/icon-badge/icon-badge.component";
import {FormInputComponent} from "../../shared/elements/form-input/form-input.component";
import {FormBuilder, FormGroup} from '@angular/forms';
import {FormButtonComponent} from "../../shared/elements/form-button/form-button.component";
import {DialogComponent} from '@syncfusion/ej2-angular-popups';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {FormDropdownComponent} from "../../shared/elements/form-dropdown/form-dropdown.component";
import { ToastModule} from '@syncfusion/ej2-angular-notifications';
import {LayoutService} from "../../shared/services/layout.service";
import {AvatarComponent} from "../../shared/elements/avatar/avatar.component";
import {TooltipModule} from "@syncfusion/ej2-angular-popups";
import {TooltipComponent} from "../../shared/elements/tooltip/tooltip.component";
import {DialogService} from "../../shared/services/dialog.service";
import {FormLabelComponent} from "../../shared/elements/form-label/form-label.component";
import {FormTextareaComponent} from "../../shared/elements/form-textarea/form-textarea.component";
import {FormCheckboxComponent} from "../../shared/elements/form-checkbox/form-checkbox.component";
import {FormDateTimeComponent} from "../../shared/elements/form-date-time/form-date-time.component";
import {FormDateComponent} from "../../shared/elements/form-date/form-date.component";
import {FormRadioComponent} from "../../shared/elements/form-radio/form-radio.component";
import {ContentComponent} from "../../shared/elements/content/content.component";
import { SliderModule, RatingModule} from '@syncfusion/ej2-angular-inputs';
import {DialogDocumentsUploadComponent} from "../../modules/documents/dialog-documents-upload/dialog-documents-upload.component";
import {RouterService} from "../../shared/services/router.service";
import {PillComponent} from "../../shared/elements/pill/pill.component";
import {FormTimeComponent} from "../../shared/elements/form-time/form-time.component";
import { FileStorageResource } from '../../shared/types/generated/fileStorageResource';
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

@Component({
    selector: 'app-workflows-stage-todo-sd',
    imports: [
        CommonModule,
        DialogModule,
        TranslatePipe,
        HeadlineComponent,
        FormInputComponent,
        FormButtonComponent,
        FormDropdownComponent,
        ToastModule,
        IconBadgeComponent,
        AvatarComponent,
        TooltipModule,
        TooltipComponent,
        FormLabelComponent,
        FormTextareaComponent,
        FormCheckboxComponent,
        FormDateTimeComponent,
        FormRadioComponent,
        ContentComponent,
        SliderModule,
        RatingModule,
        FormDateComponent,
        FormTimeComponent,
        DialogDocumentsUploadComponent,
        PillComponent,
        NgSrcImageErrorDirective
    ],
    templateUrl: './workflows-stage-todo-sd.component.html',
    styleUrl: './workflows-stage-todo-sd.component.scss'
})
export class WorkflowsStageTodoSdComponent {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  dialogService = inject(DialogService);
  routerService = inject(RouterService);

  @ViewChild('showAllStageParticipants') showAllStageParticipants: DialogComponent | any;
  @ViewChild('showAllTeamParticipants') showAllTeamParticipants: DialogComponent | any;
  /**** FORM GROUP */
  public workflowStageForm: FormGroup = this.formBuilder.group({
    radio_options: [0],
    workflow_comment:[''],
    checkbox_option: [],
    dropdown_choice: ['q2'],
    workflow_text:[''],
    datetime_answer:[''],
    date_asnwer: [''],
    is_simple_accept: true,
    accept_option: [''],
    radio_image_options: [''],
    workflow_stage_title: [''],
    workflow_stage_description: [''],
    workflow_participants_type: ['single'],
    workflow_for_all_users: [''],
    workflow_specific_users:[''],
    return_to_requester:[''],
    end_workflow_silentely:[''],
    workflow_generate_link_requesters: [''],
    timeStart: [],
    search_user_string: [],
    chat_with_participant: [],
    workflowInitationConversation: ['']
  });

  onOpenDialog = (event: any, id: string): void => {
    event.preventDefault();

    if(id == 'show-workflowstageparticipants')
      {
        this.showAllStageParticipants.show();
      }

      if(id == 'show-workflowteamparticipants')
        {
          this.showAllTeamParticipants.show();
        }
  }

  closeDialog(id = ""): void {
      if(id == 'show-workflowstageparticipants')
      {
        this.showAllStageParticipants.hide();
      }
      if(id == 'show-workflowteamparticipants')
        {
          this.showAllTeamParticipants.hide();
        }
  }

  isStageExpanded= false;
  toggleExpanded():void{
    this.isStageExpanded = !this.isStageExpanded;
  }

  dropdown_datasource: any[] = [
    {id: '1', name: 'Option 1'},
    {id: '2', name: 'Option 2'},
    {id: '3', name: 'Option 3'}
  ];

  ticks = { placement: 'After', largeStep: 1, smallStep: 0.5, showSmallTicks: true };
  public attachmentFiles: FileStorageResource[] = [];

  workflowparticipantsInitiateConversation: any[] = [
    {id: 'chat', name: 'Initiate chat with selected'},
    {id: 'meeting', name: 'Create a meeting with selected'},
  ];

  stageShow=false;
  toggleStageVisibility():void{
    this.stageShow = !this.stageShow;
  }
}
